import stayIcon60 from "../../assets/images/stay-icon-60.png";
import foodIcon60 from "../../assets/images/food-icon-60.png";
import activityIcon60 from "../../assets/images/activity-icon-60.png";
import toursIcon60 from "../../assets/images/tours-icon-60.png";
import othersIcon60 from "../../assets/images/others-icon-60.png";
import transportIcon60 from "../../assets/images/other-transport-icon-60.png";
import carIcon60 from "../../assets/images/car-icon-60.png";
import trainIcon60 from "../../assets/images/train-icon-60.png";
import flightIcon60 from "../../assets/images/flight-icon-60.png";

import staySmallIcon from "../../assets/images/stay-icon.png";
import foodSmallIcon from "../../assets/images/food-icon-black.png";
import activitySmallIcon from "../../assets/images/activity-icon-black.png";
import tourSmallIcon from "../../assets/images/tours-icon-black.png";
import otherSmallIcon from "../../assets/images/others-icon-black.png";
import transportSmallIcon from "../../assets/images/transport-other-icon.png";
import carSmallIcon from "../../assets/images/car-icon.png";
import trainSmallIcon from "../../assets/images/train-icon.png";
import flightSmallIcon from "../../assets/images/flight-icon.png";

import stayMarker from '../../assets/images/stay-marker.svg';
import activityMarker from '../../assets/images/activity-marker.svg';
import foodMarker from '../../assets/images/food-marker.svg';
import otherMarker from '../../assets/images/others-marker.svg';
import tourMarker from '../../assets/images/tours-marker.svg';
import transportMarker from '../../assets/images/transport-marker.svg';
import flightMarker from '../../assets/images/flight-marker.svg';
import trainMarker from '../../assets/images/train-marker.svg';
import carMarker from '../../assets/images/car-marker.svg';

export const getIconForDaysType = (dayType, subType) => {
  const iconMapping = {
    Stays: stayIcon60,
    Activity: activityIcon60,
    Food: foodIcon60,
    Tours: toursIcon60,
    Others: othersIcon60,
    Transports: {
      Car: carIcon60,
      Train: trainIcon60,
      Flight: flightIcon60,
      Default: transportIcon60,
    },
  };

  if (dayType === "Transports") {
    return iconMapping.Transports[subType] || iconMapping.Transports.Default;
  }

  return iconMapping[dayType] || null;
};

export const getSmallIconForDaysType = (dayType, subType) => {
  const iconMapping = {
    Stays: staySmallIcon,
    Activity: activitySmallIcon,
    Food: foodSmallIcon,
    Tours: tourSmallIcon,
    Others: otherSmallIcon,
    Transports: {
      Car: carSmallIcon,
      Train: trainSmallIcon,
      Flight: flightSmallIcon,
      Default: transportSmallIcon,
    },
  };

  if (dayType === "Transports") {
    return iconMapping.Transports[subType] || iconMapping.Transports.Default;
  }

  return iconMapping[dayType] || null;
};

export const getMarkerIconForLocationType = (dayType, subType) => {
  const iconMapping = {
    Stays: stayMarker,
    Activity: activityMarker,
    Food: foodMarker,
    Tours: tourMarker,
    Others: otherMarker,
    Transports: {
      Car: carMarker,
      Train: trainMarker,
      Flight: flightMarker,
      Default: transportMarker,
    },
  };

  if (dayType === "Transports") {
    return iconMapping.Transports[subType] || iconMapping.Transports.Default;
  }

  return iconMapping[dayType] || null;
};